module.exports = {
	"alerts": {
		"title": "Alerts",
		"alert_type": "Type",
		"message": "Message",
		"importance": "Importance",
		"event_count": "Alert count",
		"muted_until": "Muted until",
		"created_at": "Created at",
		"updated_at": "Updated at",
		"last_event_time": "Last event time",
		"not_ignore": "Don't ignore",
		"importance_type": {
			"urgent": "Urgent",
			"important": "Important",
			"regular": "Regular",
			"low": "Low",
			"daily": "Daily"
		},
		"muted_period": {
			"1hour": "1 hour",
			"6hours": "6 hours",
			"24hours": "24 hours"
		}
	}
};